export const iconFontAwesomeGamingChessRook = (
	<i className="fa-solid fa-chess-rook"></i>
);
